@for (validation of validationErrors(); track $index) {
  @if (formControlRef()?.hasError(validation.type) &&
  (formControlRef()?.dirty || formControlRef()?.touched)) {
    <ion-text class="hint-text-error" color="danger">
      <ion-icon name="information-circle-outline" aria-hidden="true" />
      {{ validation.message }}
    </ion-text>
  }
}
